import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

import MDCButton from "../core/MDCButton";

// constants
import { QES_SIGNING_START } from "../../constants/PluginConstants";

const useStyles = makeStyles((theme) => ({
  providerBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "1rem",
    padding: "0.75rem 1rem",
    marginBottom: "1.5rem",
    width: "100%",
    background: theme.palette.MDCColors.white,
    border: `1px solid ${theme.palette.MDCColors.color21}`,
    borderRadius: "6px",
  },
  providerTitle: {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: theme.palette.MDCColors.textColor,
    marginBottom: "0.25rem",
    fontFamily: theme.palette.typography.fontFamily,
  },
  providerSubtitle: {
    margin: 0,
    fontSize: "0.875rem",
    color: theme.palette.MDCColors.color18,
    fontFamily: theme.palette.typography.fontFamily,
  },
  // Banner button — override MDCButton width so it doesn't stretch
  providerBannerBtn: {
    flexShrink: 0,
    "& button": {
      whiteSpace: "nowrap",
      minWidth: "unset !important",
    },
  },
}));

// Persistent "selected provider" banner shown above every step of a QES
// signing flow, once a provider has been picked. Shared across the JP company
// flow (QESSigningStartScreen) and the Verimi flow (POARecordQES).
function QESProviderBanner({
  provider,
  onCancel,
  disabled,
  isComplete,
  showCancel,
}) {
  const { providerBanner, providerTitle, providerSubtitle, providerBannerBtn } =
    useStyles();

  return (
    <div className={providerBanner}>
      <div>
        <div className={providerTitle}>
          {QES_SIGNING_START.SELECTED_VENDOR_TITLE}: {provider?.displayName}
        </div>
        <p className={providerSubtitle}>
          {QES_SIGNING_START.SELECTED_VENDOR_SUBTITLE}
        </p>
      </div>
      {showCancel && !isComplete && (
        <div className={providerBannerBtn}>
          <MDCButton
            variant="outlined"
            label={QES_SIGNING_START.CANCEL_BUTTON}
            startIcon={<CloseIcon />}
            onClick={onCancel}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

QESProviderBanner.propTypes = {
  provider: PropTypes.shape({
    key: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isComplete: PropTypes.bool,
  showCancel: PropTypes.bool,
};

QESProviderBanner.defaultProps = {
  disabled: false,
  isComplete: false,
  showCancel: true,
};

export default QESProviderBanner;
